import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from 'reactstrap';
import StorageService from '../services/StorageService';
import axios from 'axios';
import { MdDone, MdClear, MdCreate } from 'react-icons/md';

class SiteForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      email: '',
      service: '',
      serviceList: [],
      emailError: false,
    };
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });

    if (event.target.name === 'email') {
      let result = this.validateEmail(event.target.value);
      if (!result) {
        this.setState({ emailError: !this.state.emailError });
      }
    }
  };

  handleSubmit = event => {
    event.preventDefault();

    let result = this.validateEmail(this.state.email);
    if (!result) {
      alert('Invalid Email');
      return;
    }

    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const org = StorageService.getSession('selected_org');

    const data = {
      session_key: user.session_key,
      CompanyID: org.CompanyID,
      Email: this.state.email,
      Service: this.state.service,
      Status: 'Invite',
    };

    axios
      .post(url + ':3000/v1/configuration/invite', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'User invitation sent successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  };

  validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  getServiceList = () => {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;

    const data = {
      session_key: user.session_key,
    };

    axios
      .post(url + ':3000/v1/dropdownlist/service', data)
      .then(response => {
        const result = response.data;

        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({ serviceList: result.data });
      })
      .catch(error => {
        alert(error);
      });
  };

  componentDidMount() {
    this.getServiceList();
  }

  render() {
    return (
      <Form onSubmit={this.handleSubmit} className="AuthForm">
        <ModalHeader toggle={this.props.onToggleModal()}>
          Invite User
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label for="email">Email</Label>
                <span
                  className={
                    this.state.emailError
                      ? 'ps-error d-inline'
                      : 'ps-error d-none'
                  }
                >
                  Invalid email
                </span>
                <Input
                  type="email"
                  name="email"
                  value={this.state.email || this.props.data.email}
                  onChange={this.changeHandler}
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label for="service">Zo Service</Label>
                <Input
                  type="select"
                  name="service"
                  value={this.state.service}
                  onChange={this.changeHandler}
                  required
                >
                  <option key="99" value=""></option>
                  {this.state.serviceList.length > 0 &&
                    this.state.serviceList.map((item, index) => {
                      return (
                        <option key={index} value={item.name}>
                          {item.name}
                        </option>
                      );
                    })}
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Invite
          </Button>{' '}
        </ModalFooter>
      </Form>
    );
  }
}

export default SiteForm;
